export default "__VITE_ASSET__20aae710__"